import React from "react";
import { TabbedShowLayout, Tab, TopToolbar, ShowProps } from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import Level from "./Level";
import DistanceArea from "./DistanceArea";
import Pricing from "./Pricing";
import AcademicYear from "./AcademicYear";
import BusSchedule from "./BusSchedule";
import InactivateSchoolButton from "./components/InactivateSchoolButton";
import ActivateSchoolButton from "./components/ActivateSchoolButton";
import ShowWrapper from "../../components/ShowWrapper";
import SubcontractorPricing from "./SubcontractorPricing";

const SchoolShowAction = (props: any) => {
  const { data } = props;
  return (
    <TopToolbar>
      {data && (
        <>
          {data.status === "active" ? (
            <InactivateSchoolButton schoolId={data.id} />
          ) : (
            <ActivateSchoolButton schoolId={data.id} />
          )}
        </>
      )}
    </TopToolbar>
  );
};

const SchoolShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/schools", title: "Schools" },
    { link: `/schools/${id}`, title: id },
  ];

  return (
    <ShowWrapper
      breadcrumb={breadcrumb}
      actions={<SchoolShowAction />}
      {...props}
    >
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <TabbedShowLayout>
            <Tab label="Summary">
              <Summary {...props} />
            </Tab>
            <Tab label="Level">
              <Level {...props} />
            </Tab>
            <Tab label="Bus Schedule">
              <BusSchedule {...props} />
            </Tab>
            <Tab label="Area And Location">
              <DistanceArea {...props} />
            </Tab>
            <Tab label="Academic Year">
              <AcademicYear {...props} />
            </Tab>
            <Tab label="Pricing">
              <Pricing {...props} />
            </Tab>
            <Tab label="Subcontractor Pricing">
              <SubcontractorPricing {...props} />
            </Tab>
          </TabbedShowLayout>
        </Grid>
      </SanitizedGrid>
    </ShowWrapper>
  );
};

export default SchoolShow;
